import React from 'react'
import { useParams } from 'react-router-dom'
import { useComplianceFramework } from 'src/components/async/complianceframework/useComplianceFrameworks'
import { useFrameworkSections } from 'src/components/async/Framework/useFrameworkSections'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

export const FrameworkSectionFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const { frameworkId } = useParams()
    const { data: framework } = useComplianceFramework(
      frameworkId ?? '',
      Boolean(frameworkId),
    )
    const cfModelId = framework?.getModelId() ?? ''
    const { data, isLoading, error } = useFrameworkSections(cfModelId)
    if (error) return <></>
    const sections = data?.getSectionsList() || []
    const filterValues = sections.map((section) => ({
      value: section.getModelId(),
      label: section.getName(),
    }))

    return (
      <FilterDropdown
        filterParam={FilterParam.SECTION}
        filterName={FilterName.SECTION}
        filterValues={filterValues}
        isLoading={!cfModelId || !data || isLoading}
        isNested={isNested}
      />
    )
  },
)
